/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SlovenianInputs */

const en_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slovenian`)
};

const fr_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slovene`)
};

const de_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slowenisch`)
};

const it_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sloveno`)
};

const ru_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`словенский`)
};

const es_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esloveno`)
};

const zh_cn2_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斯洛文尼亚语`)
};

const ja_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スロベニア語`)
};

const hi_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्लोवेनियाई`)
};

const pt_pt2_speechmatics_target_language_slovenian = /** @type {(inputs: Speechmatics_Target_Language_SlovenianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esloveno`)
};

/**
* | output |
* | --- |
* | "Slovenian" |
*
* @param {Speechmatics_Target_Language_SlovenianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_slovenian = /** @type {((inputs?: Speechmatics_Target_Language_SlovenianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SlovenianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_slovenian(inputs)
	if (locale === "de") return de_speechmatics_target_language_slovenian(inputs)
	if (locale === "it") return it_speechmatics_target_language_slovenian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_slovenian(inputs)
	if (locale === "es") return es_speechmatics_target_language_slovenian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_slovenian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_slovenian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_slovenian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_slovenian(inputs)
	return en_speechmatics_target_language_slovenian(inputs)
});